import { fmt } from './fmt';
import { getVerdictFromRules } from '../../../utils/mapListing';
import { getRulesSync } from '../../../services/rulesService';

/**
 * Template-based AI verdict generator.
 * Phase 1: client-side rules. Phase 2: replace with real LLM call.
 */
export function generateAiVerdict(baseline, signals, market, subscores) {
  if (!baseline) return '';
  const parts = [];
  const score = baseline.score;
  const rules = getRulesSync();

  // Opening verdict — aus Rules
  const verdictObj = getVerdictFromRules(rules, score);
  if (verdictObj) parts.push(verdictObj.label);
  else parts.push('Noch nicht bewertet');

  // Market position
  const over = baseline.marketOverMarket;
  if (over != null) {
    if (over < -20) parts.push(`${Math.abs(over)}% unter Marktdurchschnitt`);
    else if (over < -5) parts.push(`${Math.abs(over)}% unter Markt`);
    else if (over > 15) parts.push(`${over}% über Markt — hoher Einstiegspreis`);
    else if (over > 5) parts.push(`leicht über Marktdurchschnitt`);
  }

  // Cashflow assessment
  const cf = baseline.cf?.cashflow;
  if (cf != null) {
    if (cf > 200) parts.push('mit starkem positivem Cashflow');
    else if (cf > 0) parts.push('bei positivem Cashflow');
    else if (cf > -150) parts.push('bei leicht negativem Cashflow (tragbar)');
    else parts.push(`mit deutlich negativem Cashflow (${fmt(Math.abs(cf))} € Zuzahlung/Mo.)`);
  }

  // Location hint from market data
  if (market?.avg > 3000) parts.push('A-Stadt-Lage sichert langfristige Nachfrage');
  else if (market?.avg > 2000) parts.push('in B-Stadt mit solider Markttiefe');

  // Top risk signal
  const risks = signals?.filter(s => s.type === 'risk') || [];
  if (risks.length > 0) {
    parts.push(`Beachte: ${risks[0].label}`);
  }

  // Recommendation
  if (score >= 80) parts.push('Empfehlung: Zeitnah besichtigen');
  else if (score >= 65) parts.push('Empfehlung: Detailprüfung lohnt sich');
  else if (score >= 50) parts.push('Empfehlung: Nur bei klarer Upside-These');
  else if (score != null) parts.push('Empfehlung: Weitersuchen');

  return parts.join(' — ') + '.';
}
